var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"mt-4"},[_vm._v("Dashboard de l'ututilisateur "+_vm._s(_vm.user.nom))])
}
var staticRenderFns = []

export { render, staticRenderFns }